import { myPendingOrderList } from "@/apis/market";
import { FetchOrderListParams } from "@/types/Api/Order";

import { PAGE_SIZE } from "@/constants/config";
import { PendingOrder } from "@/types/Api/Market/PendingOrder/myPendingOrderDetail";
import { useInfiniteScroll } from "ahooks";
import { useRef, useState } from "react";

export const useLogic = () => {
  const [params, setParams] = useState<FetchOrderListParams>({
    page: 1,
    pageSize: PAGE_SIZE,
  });
  const scollableRef = useRef(null);
  const paramsRef = useRef({});
  const infiniteList = useInfiniteScroll<{
    list: PendingOrder[];
    total: number;
  }>(
    async (d) => {
      const page = d ? Math.ceil(d.list.length / PAGE_SIZE) + 1 : 1;
      const newParams = { ...paramsRef.current, page, pageSize: PAGE_SIZE };
      const response = await myPendingOrderList(newParams);
      if (response.ok) {
        setParams(newParams);
      }
      return {
        list: response.data?.list ?? [],
        total: response.data?.total ?? 0,
      };
    },
    {
      manual: true,
      target: scollableRef,
      isNoMore: (d) => d?.total === 0 || d?.total === d?.list.length,
    },
  );

  return {
    infiniteList,
    params,
    scollableRef,
    paramsRef,
  };
};
